/**
 * Created by adalto on 6/3/14.
 */

Greenmile.Task = Greenmile.Task || {};
Greenmile.Task.RelatedInfo = Greenmile.Task.RelatedInfo || {};

Greenmile.Task.RelatedInfo.Route = {

    validateRouteForm: function () {

        var organizationId = document.querySelector('#taskManager-route #organization_description');
        var date = document.querySelector('#taskManager-route #routeDate');
        var divAlertError = document.querySelector('#taskManager-route .alert-error');
        var monetMessage = new Monet.Form.Messages.InlineMessage();
        var errorObj = {
            errorMessages: []
        };

        if (organizationId && date) {

            if (organizationId.value.trim() === "") {
                errorObj.errorMessages.push(
                  Monet.Form.Messages.mountErrorMessageObject('TaskManager.Route.OrgananizationIsRequired'));

                organizationId.parentNode.parentNode.classList.add('error');
            }

            if (date.value.trim() === "") {
                errorObj.errorMessages.push(
                  Monet.Form.Messages.mountErrorMessageObject('TaskManager.Route.DateIsRequired'));

                date.parentNode.classList.add('error');
            }
        }

        if (errorObj.errorMessages.length > 0) {

            monetMessage.setScope("#taskManager-route");
            monetMessage.setInfoType("error");
            monetMessage.setMessage(errorObj);
            monetMessage.triggerMessage();

            return false;
        } else {
            if (divAlertError) {
                divAlertError.style.display = 'none';
                organizationId.parentNode.parentNode.classList.remove('error');
                date.parentNode.classList.remove('error');
            }

        }

        return true;

    },

    searchRoute: function () {

        var organizationId = document.querySelector('#taskManager-route #organization_id');
        var routeKey = document.querySelector('#taskManager-route #key');
        var routeDate = document.querySelector('#taskManager-route #routeDate');
        var formattedDate = Monet.Format.Date.parseLocaleToISOString(routeDate.value);

        var queryObj = {
            criteriaChain: [
                {
                    and: [
                        { attr: "key", eq: routeKey.value, matchMode: "ANYWHERE" },
                        { attr: "date", eq: formattedDate },
                        { attr: "organization.id", eq: parseInt(organizationId.value, 10) }
                    ]
                }
            ],
            sort: [
                { attr: "key", type: "ASC" }
            ]
        };

        var request = new Monet.Ajax();
        request.url = 'Route/restrictions?criteria={"filters":["id", "organization.description", "key", "date"],"firstResult":0,"maxResults":6}';
        request.method = 'post';
        request.data = queryObj;

        request.success = function (scope) {
            return function (data) {
                scope.renderRouteList(data);
            };
        }(this);

        request.error = function () {
            return function () {
                //
            };
        }();

        request.send();

    },

    renderRouteList: function (data) {

        var linkFormsForm = document.getElementById('taskManager-route');
        var routListContainer = linkFormsForm.querySelector('.GreenmileTaskRouteList');
        var routeListItem,
            organizationDesc,
            routeKey,
            routeDate,
            convertedDate;

        if (data && data.length) {

            routListContainer.innerHTML = '';

            for (var i = 0; i < data.length; i++) {

                routeListItem = document.createElement('div');
                organizationDesc = document.createElement('div');
                routeKey = document.createElement('div');
                routeDate = document.createElement('div');

                routeListItem.className = 'GreenmileTaskRouteListLine';
                organizationDesc.className = 'GreenmileTaskRouteListCloumn';
                routeKey.className = 'GreenmileTaskRouteListCloumn';
                routeDate.className = 'GreenmileTaskRouteListCloumn';

                organizationDesc.appendChild(document.createTextNode(data[i].organization.description));
                routeKey.appendChild(document.createTextNode(data[i].key));

                convertedDate = Monet.Format.Date.formatToLocale(data[i].date);

                routeDate.appendChild(document.createTextNode(convertedDate));

                routeListItem.appendChild(organizationDesc);
                routeListItem.appendChild(routeKey);
                routeListItem.appendChild(routeDate);

                routeListItem.addEventListener('click', (function (data, scope, routeListItem) {

                    return function (e) {

                        e.stopPropagation();
                        e.preventDefault();
                        e.stopImmediatePropagation();

                        scope.addItemToRouteList(data);

                        routListContainer.removeChild(routeListItem);

                    };
                }(data[i], this, routeListItem)));

                routListContainer.appendChild(routeListItem);

            }

        } else {
            routListContainer.innerHTML = Monet.I18n.getResourcesByKey('MonetUIList.noDataFound');
        }

    },

    addItemToRouteList: function (data) {

        var routeList = document.querySelector('#taskManager-route #route_list');
        var routeListItem = document.createElement('div');
        var organizationDesc = document.createElement('div');
        var routeKey = document.createElement('div');
        var routeDate = document.createElement('div');
        var trashIcon = document.createElement('div');
        var checkForCurrent = routeList.querySelector('input[value="' + data.id + '"]');

        if (!checkForCurrent) {

            var convertedDate = Monet.Format.Date.formatToLocale(data.date);
            var hiddenRouteId = document.createElement('input');

            hiddenRouteId.type = 'hidden';

            hiddenRouteId.setAttribute('name', 'route[' + data.id + '].id');
            hiddenRouteId.value = data.id;
            hiddenRouteId.className = 'modelAttribute';

            routeListItem.className = 'GreenmileTaskRouteListLine';
            organizationDesc.className = 'GreenmileTaskRouteListCloumn';
            routeKey.className = 'GreenmileTaskRouteListCloumn';
            routeDate.className = 'GreenmileTaskRouteListCloumn';
            trashIcon.className = 'table-action-destroylink';

            trashIcon.appendChild(hiddenRouteId);

            organizationDesc.appendChild(document.createTextNode(data.organization.description));
            routeKey.appendChild(document.createTextNode(data.key));
            routeDate.appendChild(document.createTextNode(convertedDate));

            trashIcon.addEventListener('click', (function (routeList, routeListItem) {
                return function (e) {

                    e.stopPropagation();
                    e.preventDefault();
                    e.stopImmediatePropagation();

                    const confirmRemoveRoute = () => {

                        var indexData = null;
                        var routeTaskedLink = null;

                        var removeFromRouteList = function () {
                            var parent = routeListItem.parentNode;
                            parent.removeChild(routeListItem);
                        };

                        var callback = function () {
                            removeFromRouteList();
                            Monet.Session.Task.lastLinkForm.routes.data.splice(indexData, 1);
                            Monet.Session.Task.lastLinkForm.routes.nodes.splice(indexData, 1);
                            Monet.Session.Task.lastLinkForm.routes.ids.splice(indexData, 1);
                        };

                        Monet.Session.Task.lastLinkForm.routes.data.forEach(function (element, index) {

                            if (hiddenRouteId.value === element.route.id.toString()) {
                                routeTaskedLink = element.id;
                                indexData = index;
                                return null;
                            }
                        });

                        if (routeTaskedLink) {
                            Greenmile.Task.RelatedInfo.deleteTaskLinked(routeTaskedLink, callback);
                        } else {
                            removeFromRouteList();
                        }

                    };

                    Greenmile.Task.RelatedInfo.showAlertToConfirm(confirmRemoveRoute);

                };
            }(routeList, routeListItem)));

            routeListItem.appendChild(organizationDesc);
            routeListItem.appendChild(routeKey);
            routeListItem.appendChild(routeDate);
            routeListItem.appendChild(trashIcon);

            routeList.appendChild(routeListItem);
        } else {
            new Greenmile.Components.AlertModal('lookuplist.messageError.exists')
                .show();
        }

    },

    createFullRouteInfo: function (data) {

        Monet.Session.Task.lastLinkForm.routes.nodes = [];
        Monet.Session.Task.lastLinkForm.routes.data = [];
        Monet.Session.Task.lastLinkForm.routes.ids = [];

        for (var i = 0, l = data.length; i < l; i++) {

            if (data[i].hasOwnProperty('route')) {
                this.createRouteIdNode(data[i]);
            }

        }

    },

    createRouteIdNode: function (data) {

        if (data) {

            var GreenmileTaskRouteListLine = document.createElement('div');
            var GreenmileTaskRouteListCloumnOrganization = document.createElement('div');
            var GreenmileTaskRouteListCloumnKey = document.createElement('div');
            var GreenmileTaskRouteListCloumnDate = document.createElement('div');
            var Destroylink = document.createElement('div');
            var input = document.createElement('input');
            var inputStatus = document.createElement('input');
            var inputLinked = document.createElement('input');
            var linkedTaskWhen = document.createElement('input');

            GreenmileTaskRouteListLine.className = "GreenmileTaskRouteListLine taskRouteLineItem";

            GreenmileTaskRouteListCloumnOrganization.className = "GreenmileTaskRouteListCloumn organization";
            GreenmileTaskRouteListCloumnKey.className = "GreenmileTaskRouteListCloumn key";
            GreenmileTaskRouteListCloumnDate.className = "GreenmileTaskRouteListCloumn date";
            Destroylink.className = "table-action-destroylink";

            GreenmileTaskRouteListCloumnOrganization.innerHTML = data.route.organization.description;
            GreenmileTaskRouteListCloumnKey.innerHTML = data.route.key;
            GreenmileTaskRouteListCloumnDate.innerHTML = Monet.Format.Date.formatToLocale(data.route.date);

            Destroylink.addEventListener('click', (function (scope, data) {

                return function (e) {

                    e.preventDefault();

                    const confirmDeleteRoute = () => {

                        App.Views.Task.showLoadingElement(this);
                        Greenmile.Task.RelatedInfo.deleteTaskLinked(data.id, (function (e) {
                            return function () {

                                App.Views.Task.hideLoad();

                                scope.removeLinkedRouteFromList(e.target);
                                scope.removeLinkedRouteFromData(e.target, scope);
                                Greenmile.Task.RelatedInfo
                                    .removeTitleContainerIfEmptyTo(
                                        Greenmile.Task.RelatedInfo.collections.ROUTES
                                    );
                            };

                        }(e)));
                    };

                    Greenmile.Task.RelatedInfo.showAlertToConfirm(confirmDeleteRoute);

                };

            }(this, data)));

            linkedTaskWhen.type = 'hidden';
            linkedTaskWhen.id = "taskLinkeds[" + data.route.id + "].when";
            linkedTaskWhen.name = "taskLinkeds[" + data.route.id + "].when";
            linkedTaskWhen.className = "modelAttribute";
            linkedTaskWhen.value = data.when || Monet.Format.DateTime.formatToISOString(new Date());

            input.type = "hidden";
            input.name = "taskLinkeds[" + data.route.id + "].route.id";
            input.id = "taskLinkeds[" + data.route.id + "].route.id";
            input.className = "modelAttribute";
            input.value = data.route.id;

            inputStatus.type = 'hidden';
            inputStatus.name = 'taskLinkeds[' + data.route.id + '].status';
            inputStatus.id = 'taskLinkeds[' + data.route.id + '].status';
            inputStatus.className = "modelAttribute";
            inputStatus.value = '';

            inputLinked.type = 'hidden';
            inputLinked.name = 'taskLinkeds[' + data.route.id + '].id';
            inputLinked.id = 'taskLinkeds[' + data.route.id + '].id';
            inputLinked.className = "modelAttribute";
            inputLinked.value = data.id || '';

            Destroylink.appendChild(input);

            GreenmileTaskRouteListLine.appendChild(GreenmileTaskRouteListCloumnOrganization);
            GreenmileTaskRouteListLine.appendChild(GreenmileTaskRouteListCloumnKey);
            GreenmileTaskRouteListLine.appendChild(GreenmileTaskRouteListCloumnDate);
            GreenmileTaskRouteListLine.appendChild(Destroylink);
            GreenmileTaskRouteListLine.appendChild(inputStatus);
            GreenmileTaskRouteListLine.appendChild(inputLinked);
            GreenmileTaskRouteListLine.appendChild(linkedTaskWhen);

            Monet.Session.Task.lastLinkForm.routes.nodes.push(GreenmileTaskRouteListLine);
            Monet.Session.Task.lastLinkForm.routes.data.push(data);
            Monet.Session.Task.lastLinkForm.routes.ids.push(input);
        }

    },

    removeLinkedRouteFromList: function (el) {

        var lineItem = el.parentNode.parentNode.parentNode;


        if (lineItem.className === 'row') {
            lineItem = el.parentNode;
        }

        var lineItemContainer = lineItem.parentNode;
        lineItemContainer.removeChild(lineItem);

    },

    removeLinkedRouteFromData: function (el) {

        var node = el.parentNode.lastChild;
        var nodes = Monet.Session.Task.lastLinkForm.routes.nodes;
        var ids = Monet.Session.Task.lastLinkForm.routes.ids;
        var data = Monet.Session.Task.lastLinkForm.routes.data;
        var nodeId = null;
        var index = null;

        for (var i = 0, l = nodes.length; i < l; i++) {

            nodeId = nodes[i].lastChild.id;

            if (nodeId === node.id) {
                index = i;
            }
        }

        if (index !== null) {
            nodes.splice(index, 1);
            ids.splice(index, 1);
            data.splice(index, 1);
            Monet.Session.Task.newTask.routes.splice(index, 1);
        }

    }

};